import { createFileRoute } from '@tanstack/react-router'

import { ConnectedMailboxesPage } from '#/modules/thecargo-mail/accounts-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/mail-accounts')({
  component: ConnectedMailboxesPage,
  validateSearch: validateListSearch,
})
